import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getReferralForms, addReferralForm, editReferralForm, deleteReferralForm, getReferralFormByKey } from "../../redux/actions/referralFormActions";
import CreateReferralForm from "./Popups/CreateReferralForm";
import ReferralFormDetails from "./Popups/ReferralFormDetails";
import EditReferralForm from "./Popups/EditReferralForm";
import RemoveReferralForm from "./Popups/RemoveReferralForm";

function createData(id, number, createdAt, schema, filial) {
    return {id, number, createdAt, schema, filial};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", null, null),
];
const ReferralFormList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("referralFormList.tableItem.id")},
        {text: t("referralFormList.tableItem.number")},
        {text: t("referralFormList.tableItem.createdAt")},
        {text: t("referralFormList.tableItem.schema")},
        {text: t("referralFormList.tableItem.filial")},
        {text: t("referralFormList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addReferralForm(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getReferralFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getReferralFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editReferralForm(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getReferralFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteReferralForm(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.referralForm);
    if (!localData && state.referralForms)
    {
        rows = state.referralForms;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getReferralForms(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("referralFormList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("referralFormList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    schema: _.schema,
                    filial: _.filial?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateReferralForm action={'create'} title={t("referralFormList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ReferralFormDetails action={'details'} title={t("referralFormList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditReferralForm action={'edit'} title={t("referralFormList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveReferralForm action={'remove'} title={t("referralFormList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ReferralFormList;
